import { useEffect } from 'react';

export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export const useSetDocumentTitle = (setDocumentTitle: VoidFunction) => {
  useEffect(() => {
    const previousTitle = document.title;
    setDocumentTitle();
    return () => {
      document.title = previousTitle;
    };
  }, [setDocumentTitle]);
};
